<template>
  <div>
    <canvas ref="canvasRef"></canvas>
  </div>
</template>

<script lang="ts" setup>
  import { ref, onMounted, PropType, computed } from 'vue';
  import { ChartData, Chart, PieController, ArcElement, Tooltip, Legend } from 'chart.js';

  const props = defineProps({
    neuVertraege: {
      type: Number as PropType<number>,
      required: true,
    },
    nachtraege: {
      type: Number as PropType<number>,
      required: true,
    },
  });

  Chart.register(PieController, ArcElement, Tooltip, Legend);

  const canvasRef = ref<HTMLCanvasElement | null>(null);

  const chartData = computed<ChartData<'pie'>>(() => ({
    labels: ['Neuverträge', 'Nachträge'],
    datasets: [
      {
        data: [props.neuVertraege, props.nachtraege],
        backgroundColor: ['#f1a82c', '#1b3c7d'],
      },
    ],
  }));

  onMounted(() => {
    if (canvasRef.value) {
      new Chart(canvasRef.value, {
        type: 'pie',
        data: chartData.value,
        options: {
          responsive: true,
          plugins: {
            legend: {
              position: 'bottom',
            },
            tooltip: {
              enabled: true,
            },
          },
        },
      });
    }
  });
</script>
